import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ConfigService } from '../../shared/utils/config.service';
import { BaseService } from '../../shared/services/base.service';

// Models
import { EmployeeSetupModel, EmployeeContractorMappingModel } from '../../shared/models/employee-setup.model';


@Injectable({
  providedIn: 'root'
})
export class EmployeeSetupService extends BaseService {
  baseApiUrl: string = '';
  postAddUpdateEmployeeApiUrl: string = '';
  getEmployeeByIDApiUrl: string = '';
  getEmployeeApiUrl: string = '';
  addEmployeeContractorMappingUrl: string = '';
  getDesignationListApiUrl: string = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseApiUrl = this.configService.getApiURI();
    this.postAddUpdateEmployeeApiUrl = this.baseApiUrl + '/Employee/AddUpdateEmployee';
    this.getEmployeeByIDApiUrl = this.baseApiUrl + '/Employee/GetEmployeeByID';
    this.getEmployeeApiUrl = this.baseApiUrl + '/Employee/GetEmployee';
    this.addEmployeeContractorMappingUrl = this.baseApiUrl + '/Employee/AddEmployeeContractorMapping';
    this.getDesignationListApiUrl = this.baseApiUrl + '/Employee/GetDesignationList';
  }

  postAddUpdateEmployee(body: EmployeeSetupModel) {
    try {
      return this.http.post(this.postAddUpdateEmployeeApiUrl, body).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }

  // Get data By tblEmployeeId basis Employee Details
  getEmployeeByID(tblEmployeeId: number, type: string) {
    try {
      return this.http.get(this.getEmployeeByIDApiUrl + '/' + tblEmployeeId + '/' + type + '/0').toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }

  // Get All Employee Details
  getEmployee(clientId: string, userRole: string, userEmail: string, sqlGlobalFilterString: string = '') {
    try {
      return this.http.get(this.getEmployeeApiUrl + '/' + clientId + '/' + userRole + '/' + userEmail + '/' + sqlGlobalFilterString).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }

  addEmployeeContractorMapping(body: EmployeeContractorMappingModel) {
    try {
      return this.http.post(this.addEmployeeContractorMappingUrl, body).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }

  // Get All DesignationList
  getDesignationList() {
    try {
      return this.http.get(this.getDesignationListApiUrl).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }

  // Get employee-data By userId
  getEmployeeByUserID(userId: string) {
    try {
      return this.http.get(this.getEmployeeByIDApiUrl + '/0/userId/' + userId).toPromise();
    } catch (Ex) {
      throw Ex;
    }
  }

}
